module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "agreement"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-signature text-muted"
  }), _vm._v(" Sharer Agreement")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_vm._v("\n           Agreement Start "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.details.started)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_vm._v("\n           Agreement Expiry "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.details.expiry)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_vm._v("\n           Agreement Term "), _c('strong', [_vm._v(_vm._s(this.term) + " months")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_vm._v("\n           Expires "), _c('strong', [_vm._v(_vm._s(this.expiry))])])], 1), _vm._v(" "), _c('p'), _c('h3', [_vm._v("Site Financials")]), _vm._v(" "), (_vm.isManager('finance|project') && !_vm.readOnly) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.editState()
      }
    }
  }, [_c('i', {
    class: _vm.editing ? 'fa fa-check-circle text-success' : 'fa fa-edit'
  })]) : _vm._e(), _vm._v(" "), (this.editing) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle text-danger"
  })]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "financeForm",
    attrs: {
      "inline": "",
      "label-position": "top",
      "model": _vm.details
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('select-sharer-status', {
    attrs: {
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.status),
      callback: function($$v) {
        _vm.$set(_vm.details, "status", $$v)
      },
      expression: "details.status"
    }
  }), _vm._v(" "), _c('select-sharer-rates', {
    attrs: {
      "sharer-id": _vm.sharer.organisation_id,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.rate_id),
      callback: function($$v) {
        _vm.$set(_vm.details, "rate_id", $$v)
      },
      expression: "details.rate_id"
    }
  }), _vm._v(" "), (_vm.details.started || _vm.editing) ? _c('date-input', {
    attrs: {
      "label": "Started",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.started),
      callback: function($$v) {
        _vm.$set(_vm.details, "started", $$v)
      },
      expression: "details.started"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.details.status !== 'Terminated' && (_vm.details.startBilling || _vm.editing)) ? _c('date-input', {
    attrs: {
      "label": "Billing from",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.startBilling),
      callback: function($$v) {
        _vm.$set(_vm.details, "startBilling", $$v)
      },
      expression: "details.startBilling"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.details.status == 'Terminated' && (_vm.details.terminated || _vm.editing)) ? _c('date-input', {
    attrs: {
      "label": "Terminated",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.terminated),
      callback: function($$v) {
        _vm.$set(_vm.details, "terminated", $$v)
      },
      expression: "details.terminated"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.details.expiry || _vm.editing) ? _c('date-input', {
    attrs: {
      "label": "Expiry",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.expiry),
      callback: function($$v) {
        _vm.$set(_vm.details, "expiry", $$v)
      },
      expression: "details.expiry"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.details && _vm.editing) ? _c('el-alert', {
    attrs: {
      "type": "warning",
      "title": "Sharer specific!",
      "description": "Only input values PER sharer. For site wide CAPEX and OPEX see Finance Summary.",
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.details.currentRate || _vm.editing) ? _c('currency-input', {
    attrs: {
      "label": "Current Fees",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.currentRate),
      callback: function($$v) {
        _vm.$set(_vm.details, "currentRate", $$v)
      },
      expression: "details.currentRate"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "If checked, the rate will be locked. When you manually adjust the rate, if will be locked.",
      "position": "bottom"
    }
  }, [(_vm.details.rateLocked || _vm.editing) ? _c('check-box', {
    attrs: {
      "label": "Rate Locked",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.rateLocked),
      callback: function($$v) {
        _vm.$set(_vm.details, "rateLocked", $$v)
      },
      expression: "details.rateLocked"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.details.discount || _vm.editing) ? _c('float-input', {
    attrs: {
      "label": "Discount",
      "prefix": _vm.details.discountPercentage ? _vm.currency : '',
      "suffix": _vm.details.discountPercentage ? '' : '%',
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.discount),
      callback: function($$v) {
        _vm.$set(_vm.details, "discount", $$v)
      },
      expression: "details.discount"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing || _vm.details.discount) ? _c('check-box', {
    attrs: {
      "label": "Disc. Type",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.discountPercentage),
      callback: function($$v) {
        _vm.$set(_vm.details, "discountPercentage", $$v)
      },
      expression: "details.discountPercentage"
    }
  }, [_vm._v("\n                         " + _vm._s(!_vm.details.discountPercentage ? '%' : _vm.currency) + "\n                       ")]) : _vm._e(), _vm._v(" "), (_vm.details.interestRate || _vm.editing) ? _c('float-input', {
    attrs: {
      "label": "Interest Rate",
      "suffix": "%",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.interestRate),
      callback: function($$v) {
        _vm.$set(_vm.details, "interestRate", $$v)
      },
      expression: "details.interestRate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.details.capex || _vm.editing) ? _c('float-input', {
    attrs: {
      "label": "Sharer Specific CAPEX",
      "decimals": 2,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.capex),
      callback: function($$v) {
        _vm.$set(_vm.details, "capex", $$v)
      },
      expression: "details.capex"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.details.opex || _vm.editing) ? _c('float-input', {
    attrs: {
      "label": "Sharer Specific OPEX",
      "decimals": 2,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.opex),
      callback: function($$v) {
        _vm.$set(_vm.details, "opex", $$v)
      },
      expression: "details.opex"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.details.updated_at) ? _c('div', [_c('small', {
    staticClass: "text-muted pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.details.updated_at)))]), (_vm.details.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.details.updated_by))]) : _vm._e()])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.canAccess('finance') && _vm.sharer.site_id && _vm.sharer.id) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('files-panel', {
    attrs: {
      "title": "License Agreement",
      "type": "site",
      "id": _vm.sharer.site_id,
      "process": "sharer",
      "process-id": _vm.sharer.id,
      "hide-carousel": ""
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "sharerInvoice",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-money-check text-muted"
  }), _vm._v(" Sharer Invoice")]), _vm._v(" "), _c('site-invoice', {
    attrs: {
      "site-data": _vm.siteData,
      "sharer-id": _vm.sharer.organisation_id,
      "org": _vm.sharer
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "sharerVO",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-screwdriver text-muted"
  }), _vm._v(" Sharer V.O.")]), _vm._v(" "), _c('site-invoice', {
    attrs: {
      "site-data": _vm.siteData,
      "sharer-id": _vm.sharer.organisation_id,
      "org": _vm.sharer,
      "is-vo": ""
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "billableEquip",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-tools text-muted"
  }), _vm._v(" Billable Equip.")]), _vm._v(" "), _c('billable-equip-table', {
    attrs: {
      "site-id": _vm.details.site_id,
      "site-data": _vm.siteData,
      "owner-id": _vm.sharer.organisation_id
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c0d42fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/finance/sharer/FinanceSharer.vue
// module id = 1432
// module chunks = 0